import React from "react";
import styled from "styled-components";

import { Form } from "--floponents-web/atoms/Form";
import SurfaceBody from "--floponents-web/atoms/Surface/SurfaceBody";
import SurfaceHeader from "--floponents-web/atoms/Surface/SurfaceHeader";
import { Heading5, NoWrap } from "--components/typography";
import { DialogCloseButton } from "--floponents-web/molecules/DialogCloseButton/DialogCloseButton";

const AddDMDialogHeading = styled(Heading5)`
    && {
        flex: initial;
        min-width: 0;
    }
`;

export interface ChooseDialogHeaderProps {
    title: string;
    onClose?: () => void;
}
export const ChooseDialogHeader = (props: ChooseDialogHeaderProps) => (
    <SurfaceHeader>
        <AddDMDialogHeading>
            <NoWrap as="div">{props.title}</NoWrap>
        </AddDMDialogHeading>
        <DialogCloseButton onClick={props.onClose} />
    </SurfaceHeader>
);

export const ChooseDialogBody = styled(SurfaceBody)`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;
export const ChooseDialogForm = styled(Form.BasicForm)`
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;
`;
export const ChooseDialogResultsList = styled.div`
    overflow-y: auto;
`;
